/**
 * Truncate a string
 * @param input to truncate
 * @param max cut off input after this amount of chars
 */
export function truncate(input = '', max) {
    return input.length > max ? input.substr(0, max).trim() + '...' : input;
}
